import formPadrao from "@/forms/solicitarOS"
import helpers from "@/cflow/helpers"

const form = helpers.copyJson(formPadrao)
// Definir form como somente leitura:
form.leitura = true
form.tecnico.ignorar = false
form.previsaoEntrega.leitura = false
form.hr1.ignorar = true
form.hr3.ignorar = true
form.h6_1.ignorar = true

export default helpers.copyJson(formPadrao)